/**
 * @license
 * Copyright DeltaBrains. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

export const environment = {
  production: false,
  name: 'DEV-FINAL',
  apiBaseUrl: 'https://api.dev-final.console.careconne.jp/',
  tokenUrl: 'https://api.dev-final.token.ck1lab.net',
  cKPassWebappUrl: 'https://dev-final.pass.ck1lab.net/',
  domainMailSupport: 'deltabrains.vn',
  excludeOnProd: false,
};
